import { dashboardActionTypes } from '../actions/types';

const initialState = {
  overview: {
    data: null,
    loading: false,
    error: null,
    lastUpdated: null,
    requestKey: null,
  },
};

export function dashboard(state = initialState, action) {
  switch (action.type) {
    case dashboardActionTypes.OVERVIEW_REQUEST:
      return {
        ...state,
        overview: {
          ...state.overview,
          loading: true,
          error: null,
          requestKey: action.requestKey,
        },
      };
    case dashboardActionTypes.OVERVIEW_SUCCESS:
      if (state.overview.requestKey !== action.requestKey) return state;
      return {
        ...state,
        overview: {
          data: action.overview,
          loading: false,
          error: null,
          lastUpdated: action.overview?.meta?.generatedAt || null,
          requestKey: action.requestKey,
        },
      };
    case dashboardActionTypes.OVERVIEW_FAILURE:
      if (state.overview.requestKey !== action.requestKey) return state;
      return {
        ...state,
        overview: {
          ...state.overview,
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
}
